import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { CONTACT_REQUEST_URL } from '~/core/constants/url'
import { Button } from '~/core/ui/Button'
import LPContainer from './LPContainer'

const ApplicantTrackingCRMBuildClientSection: FC = () => {
  const { t, i18n } = useTranslation()

  return (
    <div className="relative overflow-hidden bg-white my-[100px] tablet:my-[164px]">
      <LPContainer>
        <div className="flex flex-col tablet:flex-row items-center space-y-[28px] tablet:space-y-0">
          <div className="mr-[64px]">
            <h1 className="mb-4 animate-fadeInUp font-normal text-4.5xl text-gray-900 tablet:mb-[20]">
              <Trans i18nKey={'applicant_tracking_crm:crm:title'}>
                <p className="text-primary-400" />
                <p />
              </Trans>
            </h1>
            <div className="mx-auto animate-fadeInUp text-lg text-gray-900">
              {t('applicant_tracking_crm:crm:description')}
            </div>
            <Link
              href={CONTACT_REQUEST_URL}
              locale={i18n?.language}
              target="_blank">
              <Button
                type="secondary"
                size="xl"
                label={`${t('applicant_tracking_crm:crm:request_demo')}`}
                className="mt-9 animate-fadeInUp tablet:mt-9"
                fontWeight="font-normal"
                iconMenus="ArrowUpRight"
                icon="trailing"
              />
            </Link>
          </div>
          <div className="flex-1 relative tablet:min-w-[745px] tablet:min-h-[448px]">
            <Image
              src="/img/feature/applicant-tracking-crm/crm-1.png"
              width={745}
              height={448}
              alt="Crm 1 image"
            />
            <div className="absolute hidden tablet:block bottom-[67px] -left-[40px]">
              <Image
                src="/img/feature/applicant-tracking-crm/crm-2.png"
                width={92}
                height={92}
                alt="Crm 2 image"
              />
            </div>
            <div className="absolute tablet:hidden right-6 bottom-0">
              <Image
                src="/img/feature/applicant-tracking-crm/crm-2-mobile.png"
                width={60}
                height={0}
                alt="Crm 2 image"
              />
            </div>
          </div>
        </div>
      </LPContainer>
    </div>
  )
}

export default ApplicantTrackingCRMBuildClientSection
